import { Helmet } from "react-helmet-async";
import Sidebar from "../../../DesignSystem/Sidebar";
import "../../../../css/AML/AMLDasboard.css";
import {useEffect, useMemo, useState } from "react";
import { useUserEmail } from "../../../../context/UserEmailContext";
import { useUserRole } from "../../../../context/UserRoleContext";
import { useUserPermissions } from "../../../../context/UserPermissionsContext";
import { useNavigate } from "react-router-dom";
import AMLTable from "./Table/amlRows";
import { useAdminStatus } from "../../../../context/AdminStatusContext";
// import { canAccessAML } from "../Utils/permissions";

const AMLDashboard = () => {
  const { userEmail } = useUserEmail();
  const { userRole } = useUserRole();
  const { userPermissions } = useUserPermissions();
  const navigate = useNavigate();
  const { adminStatus } = useAdminStatus();
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 25;
  const [allRows, setAllRows] = useState([]);

  // normalize helper
  const norm = (s) => String(s || "").toLowerCase();

  // tokenize search: AND-match on all terms
  const terms = useMemo(() => norm(q).trim().split(/\s+/).filter(Boolean), [q]);

  // filter rows
  const filteredRows = useMemo(() => {
    if (terms.length === 0) return allRows;
    return allRows.filter((r) => {
      const haystack = [
        r.name,
        r.status, // e.g. "Completed" | "In progress" | "Created"
        r.result, // e.g. "Passed" | "Failed" | "Pending"
        r.createdOn, // whatever string you're using
        r.checkType,
        r.createdBy,
        // r.experianResponse,
        r.id,
      ]
        .map(norm)
        .join(" ");

      // every term must appear
      return terms.every((t) => haystack.includes(t));
    });
  }, [allRows, terms]);

  // pagination over filtered rows
  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
  const start = (page - 1) * pageSize;
  const pageRows = filteredRows.slice(start, start + pageSize);

  // reset to page 1 on query change
  useEffect(() => {
    setPage(1);
  }, [q]);

  // gate
  // const [canSeeAML, setCanSeeAML] = useState(false);

  // useEffect(() => {
  //   let mounted = true;

  //   async function checkAccess() {
  //     const allowed = await canAccessAML({
  //       userRole,
  //       userPermissions,
  //       adminEmail: userEmail,
  //     });

  //     if (mounted) setCanSeeAML(allowed);
  //   }

  //   checkAccess();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [userRole, userPermissions, userEmail]);

  // useEffect(() => {
  //   if (canSeeAML) {
  //     navigate("/MembersHub");
  //   }
  // }, [userEmail, navigate, userRole, userPermissions, adminStatus]);



  return (
    <div className="Main-Page">
      <Helmet>
        <title>check²</title>
        <meta name="description" content="check²" />
      </Helmet>

      <Sidebar />

      <AMLTable rows={pageRows} />
    </div>
  );
};

export default AMLDashboard;
